export default {
  path: 'licenses',
  name: 'publisher/licenses',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-licenses" */ './Licenses')
}
